/* eslint-disable @next/next/no-img-element */
import React, { useState } from 'react';
import ContainerHome24 from '../../atoms/ContainerHome24';
import WhiteButton from '../../atoms/WhiteButton/WhiteButton';
import Styles from './Home24HeroMegaFeiraoJul26.css';
import clsx from 'clsx';
import RedButton from '@/components/atoms/RedButton';

function Home24HeroMegaFeiraoJul26() {
  const [width, setWidth] = useState(typeof window === 'undefined' ? 0 : window.window.innerWidth);

  if (typeof window === 'undefined') {
    console.log('');
  } else {
    window.addEventListener('resize', function () {
      setWidth(window.window.innerWidth);
    });
  }
  return (
    <>
      <section id="hero-santander-financiamentos">
        <div className="bg-hero">
          {typeof window === 'undefined' ? (
            <></>
          ) : (
            <>
              {width <= 599 && (
                <picture>
                  <source type="image/png" srcSet="assets/mega-feirao-jul26/bg-320.png" />
                  <img
                    src="assets/mega-feirao-jul26/bg-320.png"
                    alt="Banner promocional Mega Feirão Webmotors com condições especiais para financiamento de veículos na Santander Financiamentos, apresentando benefícios como taxa diferenciada, carência para pagamento e parcelamento estendido."
                    className="img-bg-hero"
                  />
                </picture>
              )}
              {width > 599 && width <= 991 && (
                <picture>
                  <source type="image/png" srcSet="assets/mega-feirao-jul26/bg-600.png" />
                  <img
                    src="assets/mega-feirao-jul26/bg-600.png"
                    alt="Banner promocional Mega Feirão Webmotors com condições especiais para financiamento de veículos na Santander Financiamentos, apresentando benefícios como taxa diferenciada, carência para pagamento e parcelamento estendido."
                    className="img-bg-hero"
                  />
                </picture>
              )}
              {width > 991 && width <= 1279 && (
                <picture>
                  <source type="image/png" srcSet="assets/mega-feirao-jul26/bg-992.png" />
                  <img
                    src="assets/mega-feirao-jul26/bg-992.png"
                    alt="Banner promocional Mega Feirão Webmotors com condições especiais para financiamento de veículos na Santander Financiamentos, apresentando benefícios como taxa diferenciada, carência para pagamento e parcelamento estendido."
                    className="img-bg-hero"
                  />
                </picture>
              )}
              {width > 1279 && (
                <picture>
                  <source type="image/png" srcSet="assets/mega-feirao-jul26/bg-1280.png" />
                  <img
                    src="assets/mega-feirao-jul26/bg-1280.png"
                    alt="Banner promocional Mega Feirão Webmotors com condições especiais para financiamento de veículos na Santander Financiamentos, apresentando benefícios como taxa diferenciada, carência para pagamento e parcelamento estendido."
                    className="img-bg-hero"
                  />
                </picture>
              )}
            </>
          )}
        </div>
        <ContainerHome24>
          {typeof window === 'undefined' ? (
            <></>
          ) : (
            <>
              {width <= 599 && (
                <picture>
                  <source type="image/png" srcSet="assets/mega-feirao-jul26/img-320.png" />
                  <img src="assets/mega-feirao-jul26/img-320.png" alt="" className="img-hero" />
                </picture>
              )}
              {width > 599 && width <= 991 && (
                <picture>
                  <source type="image/png" srcSet="assets/mega-feirao-jul26/img-600.png" />
                  <img src="assets/mega-feirao-jul26/img-600.png" alt="" className="img-hero" />
                </picture>
              )}
              {width > 991 && width <= 1279 && (
                <picture>
                  <source type="image/png" srcSet="assets/mega-feirao-jul26/img-992.png" />
                  <img src="assets/mega-feirao-jul26/img-992.png" alt="" className="img-hero" />
                </picture>
              )}
              {width > 1279 && (
                <picture>
                  <source type="image/png" srcSet="assets/mega-feirao-jul26/img-1280.png" />
                  <img src="assets/mega-feirao-jul26/img-1280.png" alt="" className="img-hero" />
                </picture>
              )}
            </>
          )}
          <div className="hero-contain">
            <h1 className={clsx('figtree-700 ', 'hero-title')}>
              As melhores oportunidades de Julho estão aqui!
            </h1>
            <h2 className={clsx('figtree-400 ', 'hero-subtitle')}>
              Seu próximo veículo está em campo, com condições especiais de financiamento para você
              sair de carro novo.
            </h2>
            <WhiteButton
              href="https://www.cliente.santanderfinanciamentos.com.br/originacaocliente/?int_source=portalSF&int_medium=home-hero-banner&int_campaign=simular-agora#/dados-pessoais"
              id="hero-button-simular-financiamento"
              wide
            >
              Simular agora
            </WhiteButton>
          </div>
        </ContainerHome24>
        <style jsx>{Styles}</style>
      </section>
    </>
  );
}

export default Home24HeroMegaFeiraoJul26;
